(() => {
  const setSelected = (buttons, activeButton) => {
    buttons.forEach((button) => {
      button.setAttribute('aria-selected', String(button === activeButton));
      button.tabIndex = button === activeButton ? 0 : -1;
    });
  };

  class WepbioProductSwitcher extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.familyButtons = [...this.querySelectorAll('[data-family-target]')];
      this.familyPanels = [...this.querySelectorAll('[data-family-panel]')];
      this.coffeeButtons = [...this.querySelectorAll('[data-coffee-target]')];
      this.coffeePanels = [...this.querySelectorAll('[data-coffee-panel]')];

      this.familyButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectFamily(button.dataset.familyTarget, button));
      });

      this.coffeeButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectCoffee(button.dataset.coffeeTarget, button));
      });

      this.querySelectorAll('[data-variant-id]').forEach((button) => {
        button.addEventListener('click', () => this.selectVariant(button));
      });

      this.applyBackground(this.querySelector('[data-hero-background-family="gummies"]'));
    }

    selectFamily(family, activeButton) {
      this.dataset.family = family;
      setSelected(this.familyButtons, activeButton);
      this.familyPanels.forEach((panel) => {
        panel.hidden = panel.dataset.familyPanel !== family;
      });
      if (family === 'gummies') {
        this.applyBackground(this.querySelector('[data-hero-background-family="gummies"]'));
      } else {
        const selectedCoffee = this.coffeeButtons.find((button) => button.getAttribute('aria-selected') === 'true');
        const selectedId = selectedCoffee?.dataset.coffeeTarget || this.coffeeButtons[0]?.dataset.coffeeTarget;
        this.applyBackground(this.querySelector(`[data-hero-background-coffee="${selectedId}"]`));
      }
    }

    selectCoffee(panelId, activeButton) {
      setSelected(this.coffeeButtons, activeButton);
      this.coffeePanels.forEach((panel) => {
        panel.hidden = panel.dataset.coffeePanel !== panelId;
      });
      this.applyBackground(this.querySelector(`[data-hero-background-coffee="${panelId}"]`));
    }

    applyBackground(source) {
      const desktop = source?.dataset.backgroundDesktop || '';
      const mobile = source?.dataset.backgroundMobile || desktop;
      this.style.setProperty('--wepbio-hero-background-desktop', desktop ? `url("${desktop}")` : 'none');
      this.style.setProperty('--wepbio-hero-background-mobile', mobile ? `url("${mobile}")` : 'none');
    }

    selectVariant(activeButton) {
      const panel = activeButton.closest('[data-product-panel]');
      if (!panel) return;
      const buttons = [...panel.querySelectorAll('[data-variant-id]')];
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === activeButton)));
      const cta = panel.querySelector('[data-product-cta]');
      if (cta) cta.href = activeButton.dataset.variantUrl;
    }
  }

  class WepbioFamilyTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.buttons = [...this.querySelectorAll('[data-family-target]')];
      this.panels = [...this.querySelectorAll('[data-family-panel]')];
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          setSelected(this.buttons, button);
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.familyPanel !== button.dataset.familyTarget;
          });
        });
      });
    }
  }

  class WepbioSubscription extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.buttons = [...this.querySelectorAll('[data-subscription-target]')];
      this.cta = this.querySelector('[data-subscription-cta]');
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          setSelected(this.buttons, button);
          const family = button.dataset.subscriptionTarget;
          this.dataset.subscriptionFamily = family;
          if (this.cta) {
            this.cta.href = button.dataset.productUrl || '#';
            this.cta.textContent = button.dataset.ctaLabel;
          }
        });
      });
    }
  }

  if (!customElements.get('wepbio-product-switcher')) {
    customElements.define('wepbio-product-switcher', WepbioProductSwitcher);
  }
  if (!customElements.get('wepbio-family-tabs')) {
    customElements.define('wepbio-family-tabs', WepbioFamilyTabs);
  }
  if (!customElements.get('wepbio-subscription')) {
    customElements.define('wepbio-subscription', WepbioSubscription);
  }
})();
